import { render } from "./ConstellationBackground.vue?vue&type=template&id=2985d774"
import script from "./ConstellationBackground.vue?vue&type=script&lang=js"
export * from "./ConstellationBackground.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ConstellationBackground.vue?vue&type=style&index=0&id=2985d774&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script